import React from 'react';
import { Form } from 'react-bootstrap';
import PagesHeader from '../../../../components/base/PagesHeader';
import { FormProps } from '../types';
import classNames from 'classnames';
import useLocale from '../../../../hooks/useLocale';
import useProvisionAgreementForm from '../hooks/useProvisionAgreementForm';
import { errorHighlighter } from '../../../../util/form';
import { normalizeInputValue } from '../../../../util/util';
import { PercentageNumber } from '../../../../components/form/inputs/PercentangeNumber';
import MonthAndYearDropdown from '../../../../section/MonthAndYearDropdown';
import ErrorFeedback from '../../../../components/ErrorFeedback';

export const ProvisionAgreement = ({ context }: FormProps) => {
  const { localize } = useLocale();
  const { formGroup } = context;
  const { provisionAgreement, handleYearRateUpdate, handleUpdateProvisionAgreementInput } =
    useProvisionAgreementForm(context);

  return (
    <div>
      <PagesHeader pageTitle={'commission_agreement'} headingClass="fs-h3 font-black" translate={true} />
      <div className="form-section mb-3 dark-content-section">
        <p className="theme-text">{localize('provision_agreement_detail')}</p>
        <div>
          <div className="cr-form-row">
            <div className="month-field">
              <Form.Label className={classNames('fs-name mb-0')}>
                {localize('upto')} 12 {localize('months')} (%)
              </Form.Label>
              <PercentageNumber
                value={normalizeInputValue(provisionAgreement.firstYearRate)}
                onChangeHandler={(val) => handleYearRateUpdate('firstYearRate', val)}
                decimalPlace={2}
                inputStyle={{ textAlign: 'right', width: 70 }}
                name="firstYearRate"
              />
            </div>
            <div className="month-field">
              <Form.Label className={classNames('fs-name mb-0')}>
                12 {localize('to')} 24 {localize('months')} (%)
              </Form.Label>
              <PercentageNumber
                value={normalizeInputValue(provisionAgreement.secondYearRate)}
                onChangeHandler={(val) => handleYearRateUpdate('secondYearRate', val)}
                decimalPlace={2}
                inputStyle={{ textAlign: 'right', width: 70 }}
                name="secondYearRate"
              />
            </div>
            <div className="month-field">
              <Form.Label className={classNames('fs-name mb-0')}>
                24 {localize('to')} 36 {localize('months')} (%)
              </Form.Label>
              <PercentageNumber
                value={normalizeInputValue(provisionAgreement.thirdYearRate)}
                onChangeHandler={(val) => handleYearRateUpdate('thirdYearRate', val)}
                decimalPlace={2}
                inputStyle={{ textAlign: 'right', width: 70 }}
                name="thirdYearRate"
              />
            </div>
            <div className="month-field">
              <Form.Label className={classNames('fs-name mb-0')}>&gt; 36 {localize('months')} (%)</Form.Label>
              <PercentageNumber
                value={normalizeInputValue(provisionAgreement.postThreeYearsRate)}
                onChangeHandler={(val) => handleYearRateUpdate('postThreeYearsRate', val)}
                decimalPlace={2}
                inputStyle={{ textAlign: 'right', width: 70 }}
                name="postThreeYearsRate"
              />
            </div>
          </div>
          <div className="cr-form-row">
          <div className="provision-contract-effective-field">
            <Form.Label className="fs-name mb-0 ">
              {`${localize('contracts')} ${localize('effective_from')}`}
              <span className="d-block theme-text">{localize('contract_details_label')}</span>
            </Form.Label>{' '}
            <MonthAndYearDropdown
              startFrom={provisionAgreement.contractEffectiveFrom}
              value={provisionAgreement.contractEffectiveFrom!}
              onOptionSelect={(val) => handleUpdateProvisionAgreementInput('contractEffectiveFrom', val)}
              className={classNames(errorHighlighter(formGroup.getFieldMeta('provisionAgreement.contractEffectiveFrom')))}
            />
            <ErrorFeedback field={formGroup.getFieldMeta('provisionAgreement.contractEffectiveFrom')} />
          </div>
            <div className="reseller-agreement-field">
              <Form.Label className="fs-name mb-0">{localize('reseller_agreement')}</Form.Label>
              <Form.Select
                name="resellerAgreement"
                value={provisionAgreement?.resellerAgreement}
                onChange={(e) => handleUpdateProvisionAgreementInput('resellerAgreement', e.target.value)}
              >
                <option value="CertifiedProvider">{localize('certified_provider')}</option>
              </Form.Select>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
